import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ib-video-play",
  "use": "icon-ib-video-play-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-ib-video-play\"><path d=\"M32.0147 921.404742V102.549819C32.0147 19.992348 144.459256-28.646163 226.824733 18.392397l661.931729 377.972424c68.093915 38.84681 71.805801 120.8283 7.295776 163.834983L234.12051 1001.018304C152.970995 1055.160646 32.0147 1007.482106 32.0147 921.404742z\" p-id=\"17967\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol